export enum PATH {
	HOME = "/",
	SPLASH = "/splash",
	PRODUCT_LIST = "/product-list",
	PRODUCT_DETAIL = "/product-detail",
	INFO = "/info",
	CART = "/cart",
	PAYMENT = "/payment",
	ORDER_CONFIRMATION = "/order-confirmation",
	QR_SESSION_EXPIRED = "/qr-expired",
	SEND_TO_KITCHEN_CONFIRM = "/send-to-kitchen-confirm",
	BILL = "/bill",
	SHARE_CART = "/share-cart",
	// anchor - for code generator
}
